import React from "react";
import { FaLinkedin, FaTwitter, FaYoutube, FaEnvelope } from "react-icons/fa";
import { Heart } from "lucide-react";

const Footer = () => {
  return (
    <footer className="relative bg-black text-white py-16 overflow-hidden">
      {/* Subtle monochrome background shapes */}
      <div className="absolute -top-24 -left-24 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute -bottom-24 -right-24 w-72 h-72 bg-white opacity-5 rounded-full blur-3xl pointer-events-none"></div>

      <div className="max-w-6xl mx-auto px-6 md:px-20 flex flex-col md:flex-row justify-between items-center gap-8">
        
        {/* Branding */}
        <div className="text-center md:text-left">
          <h3 className="text-2xl font-bold mb-2 text-white">
            Kenneth Milanzi
          </h3>
          <p className="text-white/70">
            &copy; {new Date().getFullYear()}. All rights reserved.
          </p>
        </div>

        {/* Social Icons */}
        <div className="flex gap-6 text-white">
          <a
            href="https://www.linkedin.com/in/kennethmilanzi/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-70 transition transform hover:scale-110"
            aria-label="LinkedIn"
          >
            <FaLinkedin size={24} className="text-current" />
          </a>

          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-70 transition transform hover:scale-110"
            aria-label="Twitter"
          >
            <FaTwitter size={24} className="text-current" />
          </a>

          <a
            href="https://youtube.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-70 transition transform hover:scale-110"
            aria-label="YouTube"
          >
            <FaYoutube size={24} className="text-current" />
          </a>

          <a
            href="mailto:milanziksr@gmail.com"
            className="hover:opacity-70 transition transform hover:scale-110"
            aria-label="Email"
          >
            <FaEnvelope size={24} className="text-current" />
          </a>
        </div>
      </div>

      {/* Attributions */}
      <div className="mt-8 text-center text-white/60 text-sm">
        Designed with{" "}
        <Heart size={12} className="inline mx-1 text-white" /> by{" "}
        <a
          href="https://astralsolution.tech/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-white transition-colors"
        >
          Astral Solutions
        </a>
      </div>
    </footer>
  );
};

export default Footer;